import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import * as PropTypes from "prop-types";
import { QueryAccessor, SearchkitComponent, renderComponent } from "../../../../core";
import { SearchBox } from "../../search-box/SearchBox";
import { Panel } from "../../../ui";

var defaults = require("lodash/defaults");

var throttle = require("lodash/throttle");

var assign = require("lodash/assign");

var isUndefined = require("lodash/isUndefined");

export var InputFilter =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(InputFilter, _SearchkitComponent);

  function InputFilter(props) {
    var _this;

    _classCallCheck(this, InputFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputFilter).call(this, props));
    _this.translations = SearchBox.translations;
    _this.state = {
      focused: false,
      input: undefined
    };
    _this.lastSearchMs = 0;
    _this.onClear = _this.onClear.bind(_assertThisInitialized(_this));
    _this.throttledSearch = throttle(function () {
      _this.searchQuery(_this.accessor.getQueryString());
    }, props.searchThrottleTime);
    return _this;
  }

  _createClass(InputFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(InputFilter.prototype), "componentDidMount", this).call(this);
    }
  }, {
    key: "defineBEMBlocks",
    value: function defineBEMBlocks() {
      return {
        container: this.props.mod
      };
    }
  }, {
    key: "defineAccessor",
    value: function defineAccessor() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          title = _this$props.title,
          prefixQueryFields = _this$props.prefixQueryFields,
          queryFields = _this$props.queryFields,
          queryBuilder = _this$props.queryBuilder,
          queryOptions = _this$props.queryOptions,
          prefixQueryOptions = _this$props.prefixQueryOptions;
      return new QueryAccessor(id, {
        title: title,
        addToFilters: true,
        queryFields: queryFields || ["_all"],
        prefixQueryFields: prefixQueryFields,
        queryOptions: assign({}, queryOptions),
        prefixQueryOptions: assign({}, prefixQueryOptions),
        queryBuilder: queryBuilder,
        onQueryStateChange: function onQueryStateChange() {
          if (!_this2.unmounted && _this2.state.input) {
            _this2.setState({
              input: undefined
            });
          }
        }
      });
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      event.preventDefault();
      this.searchQuery(this.getValue());
    }
  }, {
    key: "searchQuery",
    value: function searchQuery(query) {
      var shouldResetOtherState = false;
      this.accessor.setQueryString(query, shouldResetOtherState);
      var now = +new Date();
      var newSearch = now - this.lastSearchMs <= 2000;
      this.lastSearchMs = now;
      this.searchkit.performSearch(newSearch);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var input = this.state.input;

      if (isUndefined(input)) {
        return this.getAccessorValue();
      } else {
        return input;
      }
    }
  }, {
    key: "getAccessorValue",
    value: function getAccessorValue() {
      return (this.accessor.state.getValue() || "") + "";
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var query = e.target.value;

      if (this.props.searchOnChange) {
        this.accessor.setQueryString(query);
        this.throttledSearch();
        this.forceUpdate();
      } else {
        this.setState({
          input: query
        });
      }
    }
  }, {
    key: "onClear",
    value: function onClear() {
      this.accessor.state = this.accessor.state.clear();
      this.searchkit.performSearch();
      this.setState({
        input: undefined
      });
    }
  }, {
    key: "setFocusState",
    value: function setFocusState(focused) {
      if (!focused) {
        var input = this.state.input;

        if (this.props.blurAction == "search" && !isUndefined(input) && input != this.getAccessorValue()) {
          this.searchQuery(input);
        }

        this.setState({
          focused: focused,
          input: undefined // Flush (should use accessor's state now)

        });
      } else {
        this.setState({
          focused: focused
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.accessor) return null;
      var _this$props2 = this.props,
          containerComponent = _this$props2.containerComponent,
          title = _this$props2.title,
          id = _this$props2.id;
      var block = this.bemBlocks.container;
      var value = this.getValue();
      return renderComponent(containerComponent, {
        title: title,
        className: id ? "filter--".concat(id) : undefined,
        disabled: this.searchkit.getHitsCount() == 0 && this.getAccessorValue() == ""
      }, React.createElement("div", {
        className: block().state({
          focused: this.state.focused
        })
      }, React.createElement("form", {
        onSubmit: this.onSubmit.bind(this)
      }, React.createElement("div", {
        className: block("icon")
      }), React.createElement("input", {
        type: "text",
        "data-qa": "input-filter",
        className: block("text"),
        placeholder: this.props.placeholder || this.translate("searchbox.placeholder"),
        value: value,
        onFocus: this.setFocusState.bind(this, true),
        onBlur: this.setFocusState.bind(this, false),
        ref: "queryField",
        autoFocus: false,
        onChange: this.onChange.bind(this)
      }), React.createElement("input", {
        type: "submit",
        value: this.translate("searchbox.button"),
        className: block("action"),
        "data-qa": "submit"
      }), React.createElement("div", {
        "data-qa": "remove",
        onClick: this.onClear,
        className: block("remove").state({
          hidden: value == ""
        })
      }))));
    }
  }]);

  return InputFilter;
}(SearchkitComponent);
InputFilter.translations = {
  "searchbox.placeholder": "Search",
  "searchbox.button": "search"
};
InputFilter.defaultProps = {
  containerComponent: Panel,
  collapsable: false,
  mod: "sk-input-filter",
  searchThrottleTime: 200,
  blurAction: "search"
};
InputFilter.propTypes = defaults({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  searchOnChange: PropTypes.bool,
  searchThrottleTime: PropTypes.number,
  queryBuilder: PropTypes.func,
  queryFields: PropTypes.arrayOf(PropTypes.string),
  queryOptions: PropTypes.object,
  prefixQueryFields: PropTypes.arrayOf(PropTypes.string),
  prefixQueryOptions: PropTypes.object,
  translations: SearchkitComponent.translationsPropType(SearchBox.translations),
  mod: PropTypes.string,
  placeholder: PropTypes.string,
  blurAction: PropTypes.string
}, SearchkitComponent.propTypes);